import React, { useMemo } from "react";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { clearPortalSession, readPortalSession } from "../../lib/storage/portalSession";

export default function PortalSuccess() {
  const { portalSlug = "" } = useParams();
  const nav = useNavigate();
  const session = useMemo(() => readPortalSession(), []);

  if (!session || session.portalSlug !== portalSlug) return <Navigate to={`/r/${portalSlug}`} replace />;

  const again = () => {
    clearPortalSession();
    nav(`/r/${portalSlug}`);
  };

  return (
    <Card sx={{ maxWidth: 480, width: "100%" }}>
      <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Stack spacing={3} alignItems="center">
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              bgcolor: "success.light",
              display: "grid",
              placeItems: "center",
            }}
          >
            <CheckCircleOutlineIcon sx={{ fontSize: 36, color: "success.main" }} />
          </Box>

          <Typography variant="h5" textAlign="center">
            You're all set!
          </Typography>
          <Typography variant="body2" color="text.secondary" textAlign="center">
            Your return for order <strong>{session.orderNumber}</strong> has been submitted for review.
          </Typography>

          <Box sx={{ width: "100%", mt: 1 }}>
            <Stepper activeStep={0} alternativeLabel>
              <Step>
                <StepLabel>System Review</StepLabel>
              </Step>
              <Step>
                <StepLabel>Shipping Label</StepLabel>
              </Step>
              <Step>
                <StepLabel>Resolved</StepLabel>
              </Step>
            </Stepper>
          </Box>

          <Button variant="contained" fullWidth onClick={() => nav(`/r/${portalSlug}/returns`)} sx={{ mt: 1 }}>
            View My Returns
          </Button>
          <Button variant="outlined" fullWidth onClick={again}>
            Start Another Return
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
